// extracted by mini-css-extract-plugin
export var container = "card-module--container--4fb08";
export var contentContainer = "card-module--contentContainer--99830";
export var date = "card-module--date--e40e0";
export var image = "card-module--image--9042a";
export var imageBadge = "card-module--imageBadge--9c0a3";
export var imageOverlay = "card-module--imageOverlay--1a0c6";
export var tagsList = "card-module--tagsList--72a3d";
export var titleWithMargin = "card-module--titleWithMargin--4b6a1";